const URL =
  process.env.ENV === 'production'
    ? 'https://www.ze.delivery'
    : 'https://release.web.ze.delivery'

export const URLS = {
  SOCIALS: {
    TWITTER: 'https://twitter.com/ZeDelivery',
    FACEBOOK: 'https://www.facebook.com/zedeliverydebebidas',
    INSTAGRAM: 'https://www.instagram.com/zedelivery',
  },
  WORK_WITH_US: 'https://bit.ly/374UOmX',
  ON_DELIVERY_PAYMENT_SUPPORT:
    'https://faq-parceiro-zedelivery.sprinklr.com/categories/pagamento-online/6218f5ea48c139668dedaf4e',
  TERMS: `${URL}/partner-terms`,
  PRIVACY: `${URL}/partner-privacy`,
  FAQ: 'https://faq-parceiro-zedelivery.sprinklr.com/',
  PARTNER_GUIDE: 'https://portalparceiro.ze.delivery/',
}
